import React from 'react';
import { Stack, Text } from '@moda/om';
import { PaymentSource } from '../../constants';
import { useCart } from '../../hooks/useCart';
import { useIsApplePaySupported } from '../ApplePay';
import { useCountry } from '../CountrySelector';
import { CheckoutAmazonPayButton } from './CheckoutAmazonPayButton';
import { CheckoutPayPalButton } from './CheckoutPayPalButton';
import { CheckoutApplePayButton } from './CheckoutApplePayButton';

import './CheckoutPaymentSources.scss';

export const CheckoutPaymentSources: React.FC = () => {
  const isApplePaySupported = useIsApplePaySupported();
  const {
    cart: {
      attributes: {
        paymentSource,
        paymentSummary: { payToday }
      }
    }
  } = useCart();
  const {
    country: { currencyCode }
  } = useCountry();

  const showApplePayButton = isApplePaySupported && payToday.price > 0;

  if (paymentSource === PaymentSource.PayPal && currencyCode !== 'USD' && !showApplePayButton)
    return null;

  return (
    <div className="CheckoutPaymentSources">
      <Text>You can also checkout with</Text>
      <Stack space={2} direction="horizontal" alignItems="center">
        {paymentSource !== PaymentSource.PayPal && <CheckoutPayPalButton size="small" />}
        {paymentSource !== PaymentSource.Apple && showApplePayButton && (
          <CheckoutApplePayButton size="small" />
        )}
        {paymentSource !== PaymentSource.Amazon && <CheckoutAmazonPayButton size="small" />}
      </Stack>
    </div>
  );
};
